import React, { useState, useEffect } from 'react'

function Steps(props) {
    let currentStep = props.getCurrent

    const [steps, setSteps] = useState({
        current: currentStep,
    })

    useEffect(() => {
        setSteps(steps => ({
            ...steps,
            current: currentStep,
        }))
    }, [currentStep])



    const handlePosition = e => {
        let position = e.target.getAttribute('data-position')
        setSteps(steps => ({
            ...steps,
            current: position,
        }))
        props.handleCurrent(position)
    }

    return (
        <div className="scroller">
            <ul className="steps">
                <li
                    data-position="1"
                    className={[
                        props.firstStepFinish ? 'finished' : 'current',
                        currentStep == 1 ? 'active' : '',
                        props.firstStepFinish && !props.secondStepFinish ? 'current-is-next' : ''
                    ].join(' ')}
                    onClick={handlePosition}
                >
                    <span>
                        {props.typeId == 1 ? 'Становище' : 'Уведомление'}
                    </span>
                </li>
                <li
                    data-position="2"
                    className={[
                        props.secondStepFinish ? 'finished' : 'current',
                        currentStep == 2 ? 'active' : '',
                        props.secondStepFinish && !props.thirdStepFinish ? 'current-is-next' : ''
                    ].join(' ')}
                    onClick={handlePosition}
                >
                    <span>
                        Протокол
                    </span>
                </li>
                <li
                    data-position="3"
                    className={[
                        props.secondStepFinish && !props.thirdStepFinish ? 'current' : '',
                        props.thirdStepFinish ? 'finished' : '',
                        currentStep == 3 ? 'active' : '',
                    ].join(' ')}
                    onClick={handlePosition}
                >
                    <span>
                        Удостоверение
                    </span>
                </li>

            </ul>
        </div>
    )
}

export default Steps